import { ProductDoc } from '@gooduncles/gu-app-schema';
import { FC, ReactNode } from 'react';

import styles from './ListItem.module.scss';

interface ProductListItemProps {
  product: ProductDoc;
  showCode?: boolean;
  rightElement?: ReactNode;
}

const ProductListItem: FC<ProductListItemProps> = ({ product, showCode, rightElement }) => {
  return (
    <div className={styles.container}>
      <div className='flexColumn' style={{ gap: 2 }}>
        {showCode && <p className={styles.productCode}>{product.productId}</p>}
        <span className={styles.productName}>{product.fullName}</span>
      </div>
      {rightElement && <div className={styles.rightContent}>{rightElement}</div>}
    </div>
  );
};

export default ProductListItem;
